export const isValidBarcodeDigit = (value: string) => {
  const val = value.slice(0, -1).padStart(13, '0');
  const checkDigit = String(
    (10 -
      (val
        .split('')
        .map((num, idx) => +num * (idx % 2 === 0 ? 3 : 1))
        .reduce((prev, cur) => prev + cur) %
        10)) %
      10,
  );
  return checkDigit === value.slice(-1);
};

export const isValidBarcodeLength = (value: string) => [8, 12, 13, 14].includes(value.length);
